import { FC } from 'react';

import { DeliverModalState } from '../hooks/useRedemptionPage';

interface Props {
  deliverModal: DeliverModalState;
  setDeliverModal: (modal: DeliverModalState | null) => void;
  onConfirm: () => void;
  onReject: (couponId: string) => void;
}

export const DeliverModal: FC<Props> = ({
  deliverModal,
  setDeliverModal,
  onConfirm,
  onReject,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="fixed inset-0 bg-black/50"
        onClick={() => setDeliverModal(null)}
      />
      <div className="relative w-full max-w-md rounded-xl bg-white p-6 shadow-2xl">
        <h3 className="text-lg font-bold text-gray-900">
          발송 처리
          {deliverModal.isBulk ? ` (${deliverModal.couponIds.length}건)` : ''}
        </h3>
        <p className="mt-1 text-sm text-gray-500">
          가격 정보를 입력한 후 발송 처리하세요.
        </p>

        <div className="mt-4 space-y-3">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              판매가 (priceRetail)
            </label>
            <div className="mt-1 flex items-center rounded-md border bg-gray-50 px-3 py-2 text-sm text-gray-500">
              {deliverModal.priceRetail.toLocaleString()}원
              <span className="ml-2 text-xs text-gray-400">(자동)</span>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              도매가 (priceWhole)
            </label>
            <input
              type="number"
              value={deliverModal.priceWhole}
              onChange={(e) =>
                setDeliverModal({ ...deliverModal, priceWhole: e.target.value })
              }
              placeholder="도매가 입력"
              className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              리베이트 (priceRebate)
            </label>
            <input
              type="number"
              value={deliverModal.priceRebate}
              onChange={(e) =>
                setDeliverModal({ ...deliverModal, priceRebate: e.target.value })
              }
              placeholder="리베이트 입력"
              className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
            />
          </div>
        </div>

        <div className="mt-6 flex items-center justify-between">
          {!deliverModal.isBulk ? (
            <button
              onClick={() => {
                const couponId = deliverModal.couponIds[0] ?? '';
                setDeliverModal(null);
                onReject(couponId);
              }}
              className="text-xs text-orange-600 hover:text-orange-800 hover:underline"
            >
              발송불가 처리
            </button>
          ) : (
            <div />
          )}
          <div className="flex gap-2">
            <button
              onClick={() => setDeliverModal(null)}
              className="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              취소
            </button>
            <button
              onClick={onConfirm}
              className="rounded-lg bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700"
            >
              발송 처리
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
